
import React, { useEffect, useState, useRef, useCallback, useMemo, useContext } from "react";
import { GameConfig, DEFAULT_CONFIG } from "./delegation-game";
import { OPTION_LABELS } from "./game";
import { activityUpdate, createGamePlayHistory } from "utils/gameApplication/gameActivityService";
import { getAverageScore } from "utils/gameApplication/gamePlayService";
import { ScoreContext } from "../GamePreview";
import { updateSwipeMiniGameBlock } from "../common";

// ── Audio context singleton ──────────────────────────────────────────
let audioCtx: AudioContext | null = null;
let audioUnlocked = false;

function unlockAudio() {
  if (audioUnlocked) return;
  try {
    if (!audioCtx) {
      audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
    }
    audioCtx.resume().then(() => {
      const osc = audioCtx!.createOscillator();
      const gain = audioCtx!.createGain();
      gain.gain.value = 0.0001;
      osc.connect(gain);
      gain.connect(audioCtx!.destination);
      osc.start();
      osc.stop(audioCtx!.currentTime + 0.01);
      audioUnlocked = true;
    }).catch(() => {
      audioUnlocked = true;
    });
  } catch (e) {
    // Audio is optional
  }
}

function playTone(kind: string = "tap") {
  if (!audioUnlocked || !audioCtx) return;
  if (audioCtx.state === "suspended") {
    audioCtx.resume();
  }

  try {
    const now = audioCtx.currentTime;
    const osc = audioCtx.createOscillator();
    const gain = audioCtx.createGain();
    osc.connect(gain);
    gain.connect(audioCtx.destination);

    if (kind === "whoosh") {
      osc.type = "triangle";
      osc.frequency.setValueAtTime(420, now);
      osc.frequency.exponentialRampToValueAtTime(120, now + 0.18);
      gain.gain.setValueAtTime(0.04, now);
      gain.gain.exponentialRampToValueAtTime(0.001, now + 0.20);
      osc.start(now);
      osc.stop(now + 0.22);
    } else if (kind === "good") {
      osc.type = "sine";
      osc.frequency.setValueAtTime(520, now);
      osc.frequency.exponentialRampToValueAtTime(880, now + 0.10);
      gain.gain.setValueAtTime(0.05, now);
      gain.gain.exponentialRampToValueAtTime(0.001, now + 0.18);
      osc.start(now);
      osc.stop(now + 0.20);
    } else if (kind === "bad") {
      osc.type = "square";
      osc.frequency.setValueAtTime(180, now);
      osc.frequency.exponentialRampToValueAtTime(120, now + 0.08);
      gain.gain.setValueAtTime(0.04, now);
      gain.gain.exponentialRampToValueAtTime(0.001, now + 0.14);
      osc.start(now);
      osc.stop(now + 0.15);
    } else if (kind === "tick") {
      osc.type = "sine";
      osc.frequency.setValueAtTime(1000, now);
      gain.gain.setValueAtTime(0.03, now);
      gain.gain.exponentialRampToValueAtTime(0.001, now + 0.05);
      osc.start(now);
      osc.stop(now + 0.06);
    } else if (kind === "complete") {
      const notes = [1318, 1047, 784];
      notes.forEach((freq, i) => {
        const o = audioCtx!.createOscillator();
        const g = audioCtx!.createGain();
        o.connect(g);
        g.connect(audioCtx!.destination);
        o.type = "sine";
        o.frequency.setValueAtTime(freq, now + i * 0.12);
        g.gain.setValueAtTime(0.04, now + i * 0.12);
        g.gain.exponentialRampToValueAtTime(0.001, now + i * 0.12 + 0.4);
        o.start(now + i * 0.12);
        o.stop(now + i * 0.12 + 0.45);
      });
      osc.type = "sine";
      osc.frequency.setValueAtTime(1, now);
      gain.gain.setValueAtTime(0, now);
      osc.start(now);
      osc.stop(now + 0.01);
      return;
    } else {
      // tap
      osc.type = "sine";
      osc.frequency.setValueAtTime(1200, now);
      gain.gain.setValueAtTime(0.03, now);
      gain.gain.exponentialRampToValueAtTime(0.001, now + 0.06);
      osc.start(now);
      osc.stop(now + 0.07);
    }
  } catch (e) {
    // Audio is optional
  }
}

// ── Default Export: Config Loader ────────────────────────────────────
const SwipeMiniGame = ({ 
   AssignId,
  setGameProgressData,
    gameProgressData,
  seconds,
 data,learner_game_play_id,gameInfo,type,Activitydata,setActivitydata,formData,learnerPlayList,setProfile,setLearnerPlayingDetails,profile,questState,onCompleted,isAudioPaused,isSwipeMiniGameCompleted,setIsSwipeMiniGameCompleted }: { 
  seconds?:any;
  gameProgressData?:any;
  setGameProgressData?:any;
  AssignId?:any;
 data?:any;
       isSwipeMiniGameCompleted?:any;
  setIsSwipeMiniGameCompleted?:any;
 gameInfo?:any;
 learner_game_play_id?:any;
type?: any;
 learnerPlayList?:any;
 formData?:any;
 setActivitydata?:any;
 Activitydata?:any;
 setProfile?:any;
 questState?:any;
 profile?:any
 setLearnerPlayingDetails?:any;
 onCompleted?: () => void;
  isAudioPaused?: boolean;
 

} = {}) => {
  const [config, setConfig] = useState<GameConfig | null>(null);
   const {setlearnerActivityrec,deviceInfo} = useContext(ScoreContext);
const [miniGameScore, setMiniGameScore] = useState(0);
const [prevAvgScore, setPrevAvgScore] = useState<number>(0);
  const [prevMiniGameBest, setPrevMiniGameBest] = useState(0);
const [bestScore, setBestScore] = useState(0);
const [currentGameScore, setCurrentGameScore] = useState(0);
  const [averageScore, setaverageScore] = useState(0)
const [histActivityId, setHistActivityId] = useState<string | null>(null);

useEffect(() => {
 const initActivity = async () => {
    try {
            let getscoreseq: any = [];
      let updatedscore: any = [];
      if (questState[parseInt(profile?.currentQuest)] === 'Started') {
        // Remove matching object from profile?.score
        getscoreseq = profile?.score?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.score;
      } else if (
        questState[parseInt(profile?.currentQuest)] === 'replayallowed'
      ) {
        // Remove matching object from profile?.replayScore
        getscoreseq = profile?.replayScore?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.replayScore;
      } else {
        getscoreseq = profile?.score?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.score;
      }
      const foundOption = getscoreseq;

      const foundOnlyOption = getscoreseq?.choosedoption;
      let total = 0;
      const scoreArray = updatedscore;

      if (scoreArray?.length > 0) {
        // STEP 2: Apply filter with logs
        const filteredData = scoreArray?.filter((cur: any, index: number) => {
          const isValidStructure =
            cur.seqId &&
            cur.scenarioId !== undefined &&
            cur.choosedoption !== undefined;

          const isQuestMatch =
            Number(cur.quest) === Number(profile.currentQuest);

          const finalResult = isValidStructure && isQuestMatch;

          return finalResult;
        });

        // STEP 3: Reduce with logs
        total = filteredData?.reduce((sum: number, cur: any, index: number) => {
          const score = Number(cur.score || 0);

          return sum + score;
        }, 0);
      }
      const conditionTypes = ['Interaction', 'response', 'feedback'];
      const updatedata = {
        galAssignedId:AssignId,
        blockname: data?.blockChoosen,
        galAverageScore: total,
        galBlockId: data?.blockSecondaryId,
        galblockleft : data?.blockSecondaryId,
        galTimeSpent: seconds,
        gameId: learner_game_play_id
      };
      const actId1 = Activitydata;
      const datas = JSON.stringify(updatedata);

      const result = await activityUpdate(datas, actId1);

      // const galId = result?.updatedData?.galId;
      const galId = result?.updatedData?.galId;
const oldScore = result?.updatedData?.galAverageScore || 0;

if (galId) {
  setHistActivityId(galId);
  // setPrevAvgScore(Number(oldScore)); // ✅ save previous
  const previous = Number(oldScore) || 0;

setPrevAvgScore(previous);
setBestScore(previous); // store best

}


      if (galId) {
        setHistActivityId(galId); // ✅ store for later update
      }
    } catch (err) {
      console.error("Activity init failed:", err);
    }
     
  };
 initActivity();
 }, []); 
  useEffect(() => {
    
    try {
      const hash = window.location.hash.slice(1);
      if (hash) {
        const decoded = JSON.parse(decodeURIComponent(atob(hash)));
        setConfig(decoded);
        return;
      }
      const saved = localStorage.getItem("delegation-game-config");
      if (saved) {
        setConfig(JSON.parse(saved));
      } else {
        setConfig(DEFAULT_CONFIG);
      }
    } catch (e) {
      console.error("Failed to load game config:", e);
      setConfig(DEFAULT_CONFIG);
    }
    
  }, []);
  const currentBlockMiniGame = useMemo(() => {
    if (!gameInfo?.ChooseMiniGame || !data?.blockId) return null;
  
    return gameInfo.ChooseMiniGame.find(
      (game: any) =>
        String(game.miniblockId) === String(data.blockId)
    );
  }, [gameInfo, data]);

  


  const buildGameConfigFromBlock = (miniGame: any): GameConfig => {

    let roundObj: any;
    
    try {
      if (typeof miniGame.roundLogic === "string") {
        roundObj = JSON.parse(miniGame.roundLogic);
      } else {
        roundObj = miniGame.roundLogic; // already an object
      }
    } catch (e) {
      console.error("Invalid roundLogic:", miniGame.roundLogic);
      return DEFAULT_CONFIG;
    }
    const rounds = roundObj ? Object.entries(roundObj).map(
    ([key, round]: any, index: number) => ({
      id: `round-${index + 1}`, // ✅ required string id
      Statement: round.Statement,
      feedback: round.feedback,
      correctAnswer: round.correctAnswer,
    })
  ): [
    {
      id: "round-1",
      Statement: "",
      feedback: "",
      correctAnswer: "",
    }
  ];
    return {
        version: 1,
        title: miniGame.MiniTitle || "Mini Game",
        subtitle: miniGame.WehaveChoose || "",
        instructions: miniGame.instructionText || "Tap on Strong / Weak to classify, or use your keyboard arrows",
        messageHeading: "",
        leftOptionLabel: miniGame?.leftOption || "WEAK",
        rightOptionLabel: miniGame?.rightOption || "STRONG",
      statementLabel:miniGame?.statementLabel || "",
        rounds,
        settings: {
        pointsPerCorrect: miniGame?.PointsPerCorrectScore || 100,
        correctLabel: miniGame?.CorrectAnswerFeedback ||"Correct",
        incorrectLabel: miniGame?.WrongAnswerFeedback ||"Not quite",
        timerEnabled: miniGame?.timerEnabled === 1 ? true : false,
        timePerRound: miniGame.Timerlimit || 30,
        allowReplay:  miniGame.ShowReplay === 1 ? true : false,
        streakMessages: { streak2: miniGame?.Streak2message || "👍 Nice!", streak3: miniGame?.Streak3message || "✨ Wow!", streak4: miniGame?.Streak4message || "🔥 On Fire!", streak5: miniGame?.Streak5message || "💯 PERFECT RUN!" },
        congratulatoryMessages: [
          { minPercent: miniGame?.Minlowscore, maxPercent: miniGame?.Maxlowscore, message: miniGame?.LowScoreMessage},
          { minPercent: miniGame?.Minmediumscore, maxPercent: miniGame?.Maxmediumscore, message: miniGame?.MediumScoreMessage },
          { minPercent:miniGame?.Minhighscore, maxPercent: miniGame?.Maxhighscore, message: miniGame?.highScoreMessage },
        ],
      },
    };
  };
  
  useEffect(() => {
    if (!currentBlockMiniGame) {
      console.warn("No mini-game for block:", data?.blockId);
      return;
    }
  
    const config = buildGameConfigFromBlock(currentBlockMiniGame);

    setConfig(config);
  
  }, [currentBlockMiniGame]);

  // Safari audio unlock
  useEffect(() => {
  
    const handler = () => {
      if (audioUnlocked) return;
      unlockAudio();
    };
    window.addEventListener("pointerdown", handler);
    window.addEventListener("touchstart", handler);
    window.addEventListener("click", handler);
    return () => {
      window.removeEventListener("pointerdown", handler);
      window.removeEventListener("touchstart", handler);
      window.removeEventListener("click", handler);
    };
  }, []);

  // save history
  const saveGameScoreHistory = async (score: any) => {
    try {
      const histdata = {
        histGameId: gameInfo.gameData.gameId,
        histQuestNo: profile.currentQuest,
        histBlockId: data.blockSecondaryId,
        histType: 'SwipeMiniGame',
        histScore: score,
        learnerid: learnerPlayList.playerId,
      };
      const stringhistdata = JSON.stringify(histdata)

      const historyResult = await createGamePlayHistory(stringhistdata);


    } catch (error) {
      console.error("Error saving game score history:", error);
    }
  };
  const getMinigameAverageScore = async () => {
    try {
      const histdata = {
        gameId: gameInfo.gameData.gameId,
        questNo: profile.currentQuest,
        blockSecondaryId: data.blockSecondaryId,
        type: 'SwipeMiniGame',
        learnerid: learnerPlayList.playerId,
        gameMode: ""
      };
      const stringhistdata = JSON.stringify(histdata)

      const historyResult = await getAverageScore(stringhistdata);
      if (historyResult?.status === "Success") {
        const score = historyResult?.maxScore || 0;

        setaverageScore(score); // update state (for UI)
        return score;
      }
     return 0;
    } catch (error) {
      console.error("Error saving game score history:", error);
      return 0;
    }
  };
 
  const handleMiniGameComplete = async (earned: number, max: number,attempt:any) => {
    setCurrentGameScore(earned);
  setlearnerActivityrec((prev:any)=>
      updateSwipeMiniGameBlock(
        prev,
        {
          blockId:data.blockId,
          attempt:attempt,
          finalscoreearned:earned
        },
        deviceInfo
      )
    );
    if (earned > averageScore) {

      await saveGameScoreHistory(earned)
    }
    const latestAverageScore = await getMinigameAverageScore();

    setIsSwipeMiniGameCompleted(true)
    const gameId = String(learner_game_play_id);
    let scenarioId = 1;    // scenario id

    // let scenarioScores = JSON.parse(localStorage.getItem("scenarioScores")) || {};

    // // create gameId if not exist
    // if (!scenarioScores[gameId]) {
    //   scenarioScores[gameId] = {};
    // }

    // // get existing score
    // let existingScore = scenarioScores[gameId][scenarioId] || 0;

    // // add new earned score
    // // scenarioScores[gameId][scenarioId] = existingScore + earned;

    // // before insert local check score 
    // const getaveragescore = averageScore;


    // if (existingScore === 0) {

    //   scenarioScores[gameId][scenarioId] = earned;

    // }

    // // SECOND TIME OR MORE
    // else if (earned > averageScore) {

    //   const difference = earned - averageScore;

    //   scenarioScores[gameId][scenarioId] = existingScore + difference;

    // }
    // // save
    // localStorage.setItem("scenarioScores", JSON.stringify(scenarioScores));

    let getscenarioScores = gameProgressData?.scenarioScores || {};

    const questNo = data?.blockQuestNo;
    const scenarioName =
      typeof data.blockScenario === 'string'
        ? parseInt(data.blockScenario.replace(/\D/g, ''), 10)
        : data.blockScenario;
    // const scenarioName = data?.blockScenario;

    if (!getscenarioScores[questNo]) {
      getscenarioScores[questNo] = {};
    }

    let getexistingScore =
      getscenarioScores[questNo][scenarioName] || 0;


    // FIRST TIME PLAY
    if (getexistingScore === 0) {
      getscenarioScores[questNo][scenarioName] = earned;
    }
    // SECOND TIME OR MORE
    else if (earned > averageScore) {
      const difference = earned - averageScore;

      getscenarioScores[questNo][scenarioName] =
        getexistingScore + difference;
    }

    setGameProgressData((prev: any) => ({
      ...prev,
      scenarioScores: getscenarioScores,
    }));

    let finalScore = prevAvgScore;

    // only add improvement
    if (earned > prevMiniGameBest) {
      const difference = earned - prevMiniGameBest;

      finalScore = prevAvgScore + difference;

      // update best mini-game score
      setPrevMiniGameBest(earned);
    }


    const histData = {
      blockname: 'SwipeMiniGame',
      galAverageScore: finalScore,
      galBlockId: data?.blockSecondaryId,
      gameId: data.gameId,

    };

    // Update UI immediately
    setMiniGameScore(finalScore);
    setBestScore(finalScore);

    // Safety check
    // if (!histActivityId) {
    //   console.warn("No histActivityId found");
    //   return;
    // }

    onCompleted?.();

    try {

      const histData = {
        blockname: "SwipeMiniGame",
        galAverageScore: finalScore, // ✅ only best score
        galBlockId: data?.blockSecondaryId,
         gameId: learner_game_play_id,
         galblockleft : data?.blockSecondaryId,
         galTimeSpent: seconds,
      };

      // Update backend
      await activityUpdate(JSON.stringify(histData), histActivityId);

      // Update local previous score
      setPrevAvgScore(finalScore);

      const seqId = data?.blockPrimarySequence;
      const questNo = parseInt(seqId.split(".")[0]);
      const numericScore = Number(earned || 0);

      // Replay / First try detection
      const isReplay =
        Object.keys(questState || {}).length > 0 &&
        questState?.[profile?.currentQuest] === "replayallowed";
      const scenarioIds =
        typeof data.blockScenario === 'string'
          ? parseInt(data.blockScenario.replace(/\D/g, ''), 10)
          : data.blockScenario;
      // Update profile score safely
      setProfile((prev: any) => {

        const targetList = isReplay ? prev.replayScore : prev.score;
        const idx = targetList.findIndex((i: any) => i.seqId === seqId);

        const updatedList = [...targetList];
     
        if (idx !== -1) {
          // Update existing
          updatedList[idx] = {
            ...updatedList[idx],
            // score: numericScore,
            score: latestAverageScore,
             choosedoption: "",
            quest: questNo,
            scenarioId: scenarioIds,
          };
        } else {
          // Insert new
          updatedList.push({
            seqId,
            // score: numericScore,
            score: latestAverageScore,
            quest: questNo,
             choosedoption: "",
            scenarioId: scenarioIds,
          });

          // Store first try only once
          // if (!isReplay) {
          //   setLearnerPlayingDetails((prevPlay: any) => ({
          //     ...prevPlay,
          //     firstTryScore: [
          //       ...prevPlay.firstTryScore,
          //       {
          //         seqId,
          //         quest: questNo,
          //         score: latestAverageScore,
          //       },
          //     ],
          //   }));
          // }
          if (!isReplay) {
  setLearnerPlayingDetails((prevPlay: any) => {
    const alreadyExists = prevPlay.firstTryScore.some(
      (item: any) => item.seqId === seqId
    );
    if (alreadyExists) return prevPlay;

    return {
      ...prevPlay,
      firstTryScore: [
        ...prevPlay.firstTryScore,
        { seqId, quest: questNo, score: latestAverageScore },
      ],
    };
  });
}
        }

        return {
          ...prev,
          [isReplay ? "replayScore" : "score"]: updatedList,
        };
      });



    } catch (err) {
      console.error("Score update failed:", err);
    }
  };
  if (!config) {
    return (
      <div className="min-h-screen bg-[#05060a] text-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-cyan-400 mx-auto mb-4"></div>
          <p className="text-white/70">Loading game...</p>
        </div>
      </div>
    );
  }

  return <DelegationGame config={config} onComplete={handleMiniGameComplete}   bestScore={bestScore}  currentGameScore={currentGameScore} isTimerPaused={isAudioPaused} averageScore={averageScore} onAnswer={(answer:any)=>{
      setlearnerActivityrec((prev:any)=>
        updateSwipeMiniGameBlock(
          prev,
          answer,
          deviceInfo
        )
      );
    }}

    blockId={data.blockId} />;
}

// ── Main Game Component ──────────────────────────────────────────────
interface DelegationGameProps {
  config: GameConfig;
  onComplete: (score: number, max: number,attempt:any) => void; // ✅
  bestScore: number; 
  currentGameScore:any;
    isTimerPaused?: boolean;
     averageScore: any;
       onAnswer:any;

blockId:any;
}

const DelegationGame: React.FC<DelegationGameProps> = ({  config,onComplete,bestScore,currentGameScore,  isTimerPaused,onAnswer,blockId }) => {

  const [currentRound, setCurrentRound] = useState(0);
  const [score, setScore] = useState(0);
    const [attempt, setattempt] = useState(1);
  const [locked, setLocked] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [timeLeft, setTimeLeft] = useState(config.settings.timePerRound);
  const [gameComplete, setGameComplete] = useState(false);

  const [showWipe, setShowWipe] = useState(false);
  const [cardAnimation, setCardAnimation] = useState<string>("");
  const [streak, setStreak] = useState(0);
  const [lastAnswer, setLastAnswer] = useState<"correct" | "incorrect" | "timeout" | null>(null);
  const [lastSwipeDir, setLastSwipeDir] = useState<string| null>(null);
  const [streakPopup, setStreakPopup] = useState<{ text: string; className: string } | null>(null);

  const cardRef = useRef<HTMLDivElement>(null);
  const statementCardRef = useRef<HTMLDivElement>(null);
  const lockedRef = useRef(false);

  // Keep lockedRef in sync
  useEffect(() => { lockedRef.current = locked; }, [locked]);

  const round = config.rounds[currentRound];
  const maxPoints = config.rounds.length * config.settings.pointsPerCorrect;
  const currentPoints = score * config.settings.pointsPerCorrect;
  const circumference = 2 * Math.PI * 18;
  const timerOffset = circumference * (1 - timeLeft / config.settings.timePerRound);
  const timerState = timeLeft <= 3 ? "danger" : timeLeft <= 6 ? "warning" : "normal";

  // Streak messages mapping
  const streakMessagesMap: Record<number, { text: string; className: string }> = {
    2: { text: config.settings.streakMessages.streak2, className: "nice" },
    3: { text: config.settings.streakMessages.streak3, className: "wow" },
    4: { text: config.settings.streakMessages.streak4, className: "unstoppable" },
    5: { text: config.settings.streakMessages.streak5, className: "perfect" },
  };
useEffect(() => {
  if (config.settings.timerEnabled) {
    setTimeLeft(config.settings.timePerRound);
  }
}, [currentRound, config.settings.timePerRound]);
  // Timer effect
  useEffect(() => {
    if (!config.settings.timerEnabled || locked || gameComplete) return;

    // setTimeLeft(config.settings.timePerRound);
    const interval = setInterval(() => {
      setTimeLeft((prev:any) => {
        if (prev <= 1) {
          clearInterval(interval);
          handleTimeout();
          return 0;
        }
        if (prev <= 3) {
          playTone("tick");
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [currentRound, locked, gameComplete]);

  const handleTimeout = () => {
    if (lockedRef.current) return;
    setLocked(true);
    setLastAnswer("timeout");
    setStreak(0);
    setShowFeedback(true);
    playTone("bad");
  };
useEffect(() => {
  if (gameComplete) {
    onComplete(currentPoints, maxPoints, attempt);
  }
}, [gameComplete]);
  const clamp = (n: number, min: number, max: number) => Math.max(min, Math.min(max, n));

  const choose = useCallback((dir: string) => {
    unlockAudio();
    if (lockedRef.current) return;
    setLocked(true);
    setLastSwipeDir(dir);

    const r:any = config.rounds[currentRound] ?? null;
  
    const isCorrect =  dir === r?.correctAnswer;
 onAnswer({

    blockId,

    attempt:attempt,

    round:currentRound + 1,

    statement:r.Statement,


    selectedOption:dir,


    correctOption:r.correctAnswer,


    isCorrect,


    score:
      isCorrect ? score + 1 : score

    });
    // Animate swipe out
    const el = statementCardRef.current;
    if (el) {
      el.style.cssText = "";
      el.classList.remove("swipe-left", "swipe-right", "enter-from-left", "enter-from-right");
      void el.offsetWidth;
      el.classList.add(dir === "WEAK" ? "swipe-left" : "swipe-right");
      playTone("whoosh");
    }

    const finishChoice = () => {
      if (isCorrect) {
        setScore((prev) => prev + 1);
        playTone("good");
        setLastAnswer("correct");
        setStreak((prev) => {
          const newStreak = prev + 1;
          const msgData = streakMessagesMap[newStreak];
          if (msgData && msgData.text) {
            setStreakPopup(msgData);
            setTimeout(() => setStreakPopup(null), 1000);
          }
          return newStreak;
        });
      } else {
        playTone("bad");
        setLastAnswer("incorrect");
        setStreak(0);
      }
      setShowFeedback(true);
    };

    // Wait for swipe animation to finish
    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      el?.removeEventListener("animationend", finish);
      finishChoice();
    };
    if (el) {
      el.addEventListener("animationend", finish, { once: true });
      setTimeout(finish, 350); // fallback
    } else {
      finishChoice();
    }
  }, [currentRound, config.rounds]);

  const handleContinue = () => {
   
    playTone("tap");
    setShowFeedback(false);
  
    if (currentRound >= config.rounds.length - 1) {
      setGameComplete(true);
      const earned = score * config.settings.pointsPerCorrect;
      const max = maxPoints;

      // onComplete(earned, max); // ✅ Send score up
    } else {
      setShowWipe(true);
      playTone("whoosh");
      setTimeout(() => {
        // Reset statement card before advancing round
        const el = statementCardRef.current;
        if (el) {
          el.classList.remove("swipe-left", "swipe-right", "enter-from-left", "enter-from-right");
          el.style.cssText = "";
        }
        setCurrentRound((prev) => prev + 1);
        setLocked(false);
        setShowFeedback(false);
        setLastAnswer(null);
        setShowWipe(false);
      }, 500);
    }
  };

  const handleReplay = () => {
    const newattempt = attempt + 1;
    setattempt(newattempt);
    unlockAudio();
    playTone("tap");
    setCurrentRound(0);
    setScore(0);
    setLocked(false);
    setShowFeedback(false);
    setLastAnswer(null);
    setGameComplete(false);
    setStreak(0);
    setLastSwipeDir(null);
    setTimeLeft(config.settings.timePerRound);
  };

  const getCongratulatoryMessage = () => {
    const percent = (score / config.rounds.length) * 100;
    const msg = config.settings.congratulatoryMessages.find(
      (m:any) => percent >= m.minPercent && percent <= m.maxPercent
    );
    return msg?.message || "Game complete!";
  };

  // Keyboard support
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === "ArrowLeft") {
        choose(config.leftOptionLabel);
      } else if (e.key === "ArrowRight") {
        choose(config.rightOptionLabel);
      }
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [choose]);

  // ── Drag/swipe handling ──
  const dragging = useRef(false);
  const startX = useRef(0);
  const lastX = useRef(0);
  const moved = useRef(0);
  const velocity = useRef(0);
  const lastTime = useRef(0);

  const onPointerDown = (e: React.PointerEvent) => {
    unlockAudio();
    if (lockedRef.current) return;
    dragging.current = true;
    startX.current = e.clientX;
    lastX.current = e.clientX;
    moved.current = 0;
    velocity.current = 0;
    lastTime.current = Date.now();
    (e.target as HTMLElement).setPointerCapture(e.pointerId);
    if (statementCardRef.current) {
      statementCardRef.current.style.transition = "none";
    }
  };

  const onPointerMove = (e: React.PointerEvent) => {
    if (!dragging.current || lockedRef.current) return;
    const dx = e.clientX - startX.current;
    moved.current = dx;

    const now = Date.now();
    const dt = now - lastTime.current;
    if (dt > 0) {
      velocity.current = (e.clientX - lastX.current) / dt;
    }
    lastX.current = e.clientX;
    lastTime.current = now;

    if (statementCardRef.current) {
      const rotate = clamp(dx * 0.02, -5, 5);
      statementCardRef.current.style.transform = `translateX(${dx}px) rotate(${rotate}deg)`;
      const opacity = 1 - Math.min(Math.abs(dx) / 350, 0.35);
      statementCardRef.current.style.opacity = String(opacity);
    }
  };

  const onPointerUp = () => {
    if (!dragging.current) return;
    dragging.current = false;

    const flickThreshold = 0.5;
    const distanceThreshold = 60;
    const isFlick = Math.abs(velocity.current) > flickThreshold;
    const isFarEnough = Math.abs(moved.current) > distanceThreshold;

    if (isFlick || isFarEnough) {
      const dir: string =
        moved.current < 0 || velocity.current < -flickThreshold ? config.leftOptionLabel : config.rightOptionLabel;
      // Don't reset styles — the choose() animation takes over
      if (statementCardRef.current) {
        statementCardRef.current.style.transition = "";
      }
      choose(dir);
    } else {
      // Snap back
      if (statementCardRef.current) {
        statementCardRef.current.style.transition = "";
        statementCardRef.current.style.transform = "";
        statementCardRef.current.style.opacity = "";
      }
    }
  };

  const onPointerCancel = () => {
    dragging.current = false;
    if (statementCardRef.current) {
      statementCardRef.current.style.transition = "";
      statementCardRef.current.style.transform = "";
      statementCardRef.current.style.opacity = "";
    }
  };

  // Enter animation class for statement card
  const getEnterClass = () => {
    if (!lastSwipeDir) return "";
    return lastSwipeDir === "WEAK" ? "enter-from-right" : "enter-from-left";
  };

  const correctLabel = config.settings.correctLabel || "";
  const incorrectLabel = config.settings.incorrectLabel || "";

  return (
    <GameContainer>
      {gameComplete && <ConfettiCanvas />}
      <div className="w-full h-full" data-aos="slide-up" data-aos-delay="200" data-aos-once="true">
      <div
        className={`card p-4 ${cardAnimation} ${gameComplete ? "complete-glow" : ""}`}
        ref={cardRef}
         style={gameComplete ? {
          borderColor: 'rgba(54,231,255,.5)',
          boxShadow: '0 0 60px rgba(54,231,255,.25), 0 0 120px rgba(180,107,255,.15)'
        } : undefined}
      >
        {/* Wipe transition */}
        {showWipe && (
          <div className="wipe" style={{ display: "grid" }}>
            <div className="msg">
              <div style={{ fontSize: "20px", color: "rgba(255,255,255,0.85)", fontWeight: 600, letterSpacing: "1px", marginBottom: "10px" }}>
                Next Up...
              </div>
              <div className="bar"><i></i></div>
            </div>
          </div>
        )}

        {/* Feedback overlay */}


        {/* Streak popup */}
        {streakPopup && (
          <div className={`streak-popup ${streakPopup.className}`}>
            {streakPopup.text}
          </div>
        )}

        {/* Top bar — hide on completion */}
        {!gameComplete && (
          <div className="topbar">
            <div className="title">
              {/* <h1 style={{ fontWeight: 700 }}>{config.title}</h1> */}

              {/* <h1
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "",
    lineHeight: "1.5",
    margin: 0,
  }}
> */}
 {/* <h1
  className="text"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "16px"
        : "inherit",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  {config.title}
</h1> */}

<h1
  className="text"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "20px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  {config.title}
</h1>
              {/* <p>{config.subtitle}</p> */}
                           {/* <p
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "",
    // margin: 0,
    // lineHeight: "1.5",
  }}
>
  {config.subtitle}
</p> */}

<p
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "19px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
  }}
>
  {config.subtitle}
</p>
            </div>
            {/* <div className="badge">
              <span className="pts">
                <b>{currentPoints}</b>
                <span style={{ opacity: 0.55 }}>/</span>
                <span>{maxPoints}</span>
                <span style={{ opacity: 0.6 }}>pts</span>
              </span>
              <span style={{ opacity: 0.25 }}>|</span>
              <span style={{ display: "flex", alignItems: "center", gap: "7px" }}>
                <span className="dot"></span>
                <span>Round {currentRound + 1}/{config.rounds.length}</span>
              </span>
              {streak >= 2 && (
                <span className="streak-badge">🔥 <span>{streak}</span></span>
              )}
            </div> */}

            {/* <div
  className="badge"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "",
    lineHeight: "1.5",
    margin: 0,
  }}
> */}

<div
  className="badge"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "18px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  {/* <span
    className="pts"
    style={{
      fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "",
      lineHeight: "1.5",
      margin: 0,
    }}
  > */}

  <span
  className="pts"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "18px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
    <b>{currentPoints}</b>
    <span style={{ opacity: 0.55 }}>/</span>
    <span>{maxPoints}</span>
    <span style={{ opacity: 0.6 }}>pts</span>
    {/* <span
  style={{
    opacity: 0.6,
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "",
    lineHeight: "1.5",
    margin: 0,
    
  }}
>
  pts
</span> */}
  </span>

  <span style={{ opacity: 0.25 }}>|</span>

  {/* <span
    style={{
      display: "flex",
      alignItems: "center",
      gap: "7px",
      fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "",
      lineHeight: "1.5",
      margin: 0,
    }}
  > */}

  <span
  style={{
    display: "flex",
    alignItems: "center",
    gap: "7px",
    fontSize:
      window.devicePixelRatio <= 1
        ? "16px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
    <span className="dot"></span>
    <span>Round {currentRound + 1}/{config.rounds.length}</span>
  </span>

  {streak >= 2 && (
    // <span
    //   className="streak-badge"
    //   style={{
    //     fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "",
    //     lineHeight: "1.5",
    //     margin: 0,
    //   }}
    // >

    <span
  className="streak-badge"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "18px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
      🔥 <span>{streak}</span>
    </span>
  )}
</div>
          </div>
        )}

        {/* Content */}
        <div className="content">
          {gameComplete ? (
            <div className="complete">
              <div style={{ fontSize: "48px" }}>🎉</div>
              <h2>Congratulations!</h2>
              {/* <p className="subtitle">You completed the mini-game.</p> */}

              {/* <p
  className="subtitle"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "17px" : "",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  You completed the mini-game.
</p> */}

<p
  className="subtitle"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "19px"
        : window.devicePixelRatio <= 1.5
        ? "16px"
        : "17px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  You completed the mini-game.
</p>
              {/* <div className="bigScore">{bestScore}/{maxPoints} pts</div> */}
              <div className="bigScore">{currentGameScore}/{maxPoints} pts</div>
              {/* <p className="message">{getCongratulatoryMessage()}</p> */}
              {/* <p
  className="message"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "17px" : "",
    lineHeight: "1.5",
    margin: 0,
    whiteSpace: "nowrap",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  }}
> */}

<p
  className="message"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "19px"
        : window.devicePixelRatio <= 1.5
        ? "16px"
        : "17px",
    lineHeight: "1.5",
    margin: 0,
    whiteSpace: "nowrap",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  }}
>
  {getCongratulatoryMessage()}
</p>
              {config.settings.allowReplay && (
                  <button className="replay-btn" onClick={handleReplay}>
                  <span style={{ display: "inline-flex" }}>↻</span> Replay Mini-Game
                </button>
              )}
              {/* <p style={{ marginTop: "8px", fontSize: "12px", color: "rgba(255,255,255,.50)" }}>
                Or click on the <b>Next</b> button at the right to proceed to the next interaction.
              </p> */}

              {/* <p
  style={{
    marginTop: "8px",
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "17px" : "",
    lineHeight: "1.5",
    margin: 0,
    color: "rgba(255,255,255,.50)",
  }}
> */}

<p
  style={{
    marginTop: "8px",
    fontSize:
      window.devicePixelRatio <= 1
        ? "19px"
        : window.devicePixelRatio <= 1.5
        ? "16px"
        : "17px",
    lineHeight: "1.5",
    margin: 0,
    color: "rgba(255,255,255,.50)",
  }}
>
  Or click on the <b>Next</b> button at the right to proceed to the next interaction.
</p>
            </div>
          ) : (
            <>
              {/* Instruction bar */}
              <div className="instruction">
                {/* <div className="q"> */}
                {/* <div
  className="q"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "",
    lineHeight: "1.5",
  }}
> */}

<div
  className="q"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "19px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
  }}
>
                  <span>
                    {config.instructions}{" "}
                    <span className="arrowKey">←</span>
                    <span className="arrowKey">→</span>
                  </span>
                </div>
                {config.settings.timerEnabled && (
                  <div className={`timer-ring ${timerState}`}>
                    <svg viewBox="0 0 44 44">
                      <circle className="timer-bg" cx="22" cy="22" r="18" fill="none" strokeWidth="3" stroke="rgba(255,255,255,.1)" />
                      <circle
                        className="timer-progress"
                        cx="22"
                        cy="22"
                        r="18"
                        fill="none"
                        strokeWidth="3"
                        strokeDasharray={circumference}
                        strokeDashoffset={timerOffset}
                        strokeLinecap="round"
                        style={{
                          stroke: timerState === "danger" ? "var(--bad)" : timerState === "warning" ? "var(--gold)" : "var(--cyan)",
                          transition: "stroke-dashoffset 1s linear, stroke 0.3s ease",
                        }}
                      />
                    </svg>
                    {/* <div className="timer-text">{timeLeft}</div> */}
                    {/* <div
  className="timer-text"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "",
    lineHeight: "1.5",
    margin: 0,
  }}
> */}

<div
  className="timer-text"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "18px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  {timeLeft}
</div>
                  </div>
                )}
              </div>

              {/* Board */}
              <div className="board">
                  <button
                    data-aos="zoom-out"
                    data-aos-delay="600"
                  className="side"
                  onClick={() => choose(config.leftOptionLabel)}

                  disabled={locked}
                >
                  <div className="label">
                    <div className="chip">
                      <div className="flex items-center w-6 h-6">
                        <div className="text-[16px] p-[5px_5px_5px_2px]">◀</div>
                      </div>
                    </div>
                    <span className="text-[14px] tracking-[1.35px] font-sans">{config.leftOptionLabel}</span>
                  </div>
                </button>

                <div className="centre">
                  <div
                    className={`statementCard ${showFeedback ? "" : getEnterClass()}`}
                    ref={statementCardRef}
                    onPointerDown={onPointerDown}
                    onPointerMove={onPointerMove}
                    onPointerUp={onPointerUp}
                    onPointerCancel={onPointerCancel}
                  >
                    {/* <div className="chipTop">{config.statementLabel}</div> */}
                    {/* <div
  className="chipTop"
  style={{
    opacity: 0.6,
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "",
    lineHeight: "1.5",
    margin: 0,
   
  }}
> */}

<div
  className="chipTop"
  style={{
    opacity: 0.6,
    fontSize:
      window.devicePixelRatio <= 1
        ? "18px"
        : window.devicePixelRatio <= 1.5
        ? "15px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  {config.statementLabel}
</div>
                    <p className="statementText">{round?.Statement || "…"}</p>
                  </div>
                </div>

                <button
                    data-aos="zoom-out"
                    data-aos-delay="600"
                  className="side"
                  onClick={() => choose(config.rightOptionLabel)}
                  disabled={locked}
                >
                  <div className="label">
                    <div className="chip">
                      <div className="flex items-center w-6 h-6">
                        <div className="text-[16px] p-[5px_5px_5px_3px]">▶</div>
                      </div>
                    </div>
                    <span className="text-[14px] tracking-[1.35px] font-sans">{config.rightOptionLabel}</span>
                  </div>
                </button>
              </div>
            </>
          )}
        </div>
      </div>
      </div>
      {showFeedback && !gameComplete && (
        <div className="fixed inset-0 z-50 flex items-center justify-center" >
          <div className="fbOverlay show w-[500px] ">
            <div className={`feedback ${lastAnswer === "correct" ? "good" : "bad"}`}>
              <div className="fbHead"
              
  
              >
                <div>
                  {/* <strong
                               style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "",
    lineHeight: "1.5",
  }}
                  > */}

                  <strong
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "19px"
        : window.devicePixelRatio <= 1.5
        ? "13px"
        : "16px",
    lineHeight: "1.5",
  }}
>
                    {lastAnswer === "timeout"
                      ? "Time's up!"
                      : lastAnswer === "correct"
                        ? correctLabel
                        : incorrectLabel}
                  </strong>
                </div>
              </div>
              {/* <div className="fbBody"> */}
              {/* <div
  className="fbBody"
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "",
    lineHeight: "1.5",
  }}
> */}

<div
  className="fbBody"
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "18px"
        : window.devicePixelRatio <= 1.5
        ? "13px"
        : "16px",
    lineHeight: "1.5",
  }}
>
                {lastAnswer === "timeout"
                  ? "You ran out of time to make a choice."
                  : round?.feedback || ""}
              </div>
              <div className="fbActions">
                {/* <button className="ghost" onClick={() => handleContinue()}>Got it</button> */}
                {/* <button
  className="ghost"
  onClick={() => handleContinue()}
  style={{
    fontSize: Math.abs(window.devicePixelRatio - 1) < 0.05 ? "16px" : "",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  Got it
</button> */}

<button
  className="ghost"
  onClick={() => handleContinue()}
  style={{
    fontSize:
      window.devicePixelRatio <= 1
        ? "18px"
        : window.devicePixelRatio <= 1.5
        ? "13px"
        : "16px",
    lineHeight: "1.5",
    margin: 0,
  }}
>
  Got it
</button>
              </div>
            </div>
          </div>
        </div>
      )}

    </GameContainer>
  );
};

// ── Confetti Canvas ──────────────────────────────────────────────────
const ConfettiCanvas: React.FC = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    playTone("complete");

    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const particles: any[] = [];
    const colors = [
      "rgba(54, 231, 255, 0.9)",
      "rgba(180, 107, 255, 0.9)",
      "rgba(255, 211, 107, 0.9)",
      "rgba(76, 255, 176, 0.9)",
      "rgba(255, 107, 205, 0.9)",
      "rgba(100, 255, 218, 0.9)",
    ];

    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;

    for (let i = 0; i < 120; i++) {
      const angle = (Math.PI * 2 * i) / 120 + Math.random() * 0.5;
      const speed = Math.random() * 8 + 4;
      particles.push({
        x: centerX,
        y: centerY,
        size: Math.random() * 6 + 3,
        color: colors[Math.floor(Math.random() * colors.length)],
        speedX: Math.cos(angle) * speed,
        speedY: Math.sin(angle) * speed,
        rotation: Math.random() * 360,
        rotationSpeed: Math.random() * 15 - 7.5,
        alpha: 1,
        decay: Math.random() * 0.015 + 0.008,
        type: Math.random() > 0.5 ? "hex" : "diamond",
      });
    }

    const drawHex = (x: number, y: number, size: number, rotation: number) => {
      ctx.beginPath();
      for (let i = 0; i < 6; i++) {
        const a = (Math.PI / 3) * i + rotation;
        const px = x + size * Math.cos(a);
        const py = y + size * Math.sin(a);
        if (i === 0) ctx.moveTo(px, py); else ctx.lineTo(px, py);
      }
      ctx.closePath();
    };

    const drawDiamond = (x: number, y: number, size: number, rotation: number) => {
      ctx.beginPath();
      for (let i = 0; i < 4; i++) {
        const a = (Math.PI / 2) * i + rotation;
        const px = x + size * Math.cos(a);
        const py = y + size * Math.sin(a);
        if (i === 0) ctx.moveTo(px, py); else ctx.lineTo(px, py);
      }
      ctx.closePath();
    };

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach((p) => {
        p.x += p.speedX;
        p.y += p.speedY;
        p.speedY += 0.15;
        p.speedX *= 0.99;
        p.rotation += p.rotationSpeed;
        p.alpha -= p.decay;
        if (p.alpha > 0) {
          ctx.save();
          ctx.globalAlpha = p.alpha;
          ctx.fillStyle = p.color;
          ctx.shadowBlur = 12;
          ctx.shadowColor = p.color;
          if (p.type === "hex") drawHex(p.x, p.y, p.size, (p.rotation * Math.PI) / 180);
          else drawDiamond(p.x, p.y, p.size, (p.rotation * Math.PI) / 180);
          ctx.fill();
          ctx.restore();
        }
      });
      if (particles.some((p) => p.alpha > 0)) requestAnimationFrame(animate);
    };
    animate();
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{ position: "fixed", inset: 0, width: "100%", height: "100%", pointerEvents: "none", zIndex: 9999 }}
    />
  );
};

// ── Starfield Background ─────────────────────────────────────────────
const StarfieldCanvas: React.FC = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const starsRef = useRef<any[]>([]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const DPR = Math.min(2, window.devicePixelRatio || 1);
    let W = 0, H = 0;

    const resize = () => {
      W = canvas.width = Math.floor(window.innerWidth * DPR);
      H = canvas.height = Math.floor(window.innerHeight * DPR);
      canvas.style.width = window.innerWidth + "px";
      canvas.style.height = window.innerHeight + "px";
      makeStars();
    };

    const makeStars = () => {
      starsRef.current = [];
      const count = Math.min(220, Math.floor((window.innerWidth * window.innerHeight) / 9000));
      for (let i = 0; i < count; i++) {
        starsRef.current.push({
          x: Math.random() * W,
          y: Math.random() * H,
          r: Math.random() * 1.2 + 0.2,
          a: Math.random() * 0.7 + 0.15,
          v: (Math.random() * 0.35 + 0.05) * DPR,
          isAmbient: false,
        });
      }
      // Ambient particles
      for (let i = 0; i < 20; i++) {
        starsRef.current.push({
          x: Math.random() * W,
          y: Math.random() * H,
          r: Math.random() * 3 + 2,
          a: Math.random() * 0.12 + 0.04,
          vx: (Math.random() * 0.1 - 0.05) * DPR,
          vy: -(Math.random() * 0.3 + 0.15) * DPR,
          isAmbient: true,
          color: Math.random() > 0.5 ? "cyan" : "violet",
          pulsePhase: Math.random() * Math.PI * 2,
          pulseSpeed: Math.random() * 0.02 + 0.01,
        });
      }
    };

    const draw = () => {
      ctx.clearRect(0, 0, W, H);
      for (const s of starsRef.current) {
        if (s.isAmbient) {
          s.x += s.vx;
          s.y += s.vy;
          if (s.y < -20) { s.y = H + 20; s.x = Math.random() * W; }
          if (s.x < -20) s.x = W + 20;
          if (s.x > W + 20) s.x = -20;
          s.pulsePhase += s.pulseSpeed;
          const pulseAlpha = s.a * (0.6 + 0.4 * Math.sin(s.pulsePhase));
          const baseColor = s.color === "cyan" ? "54,231,255" : "180,107,255";
          ctx.save();
          ctx.shadowBlur = 15;
          ctx.shadowColor = `rgba(${baseColor},${pulseAlpha * 2})`;
          ctx.beginPath();
          ctx.arc(s.x, s.y, s.r * DPR, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(${baseColor},${pulseAlpha})`;
          ctx.fill();
          ctx.restore();
        } else {
          s.a += (Math.random() - 0.5) * 0.02;
          s.a = Math.max(0.08, Math.min(0.85, s.a));
          ctx.globalAlpha = s.a;
          ctx.beginPath();
          ctx.arc(s.x, s.y, s.r * DPR, 0, Math.PI * 2);
          ctx.fillStyle = "white";
          ctx.fill();
          s.y += s.v;
          if (s.y > H + 4) { s.y = -4; s.x = Math.random() * W; }
        }
      }
      ctx.globalAlpha = 1;
      requestAnimationFrame(draw);
    };

    resize();
    window.addEventListener("resize", resize);
    draw();
    return () => window.removeEventListener("resize", resize);
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{ position: "fixed", inset: 0, width: "100%", height: "100%", zIndex: 0 }}
    />
  );
};

// ── Game Container ───────────────────────────────────────────────────
const GameContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <>
      <style>{gameStyles}</style>
      <div className="game-root">
        <StarfieldCanvas />
        <div className="scanlines"></div>
        <div className="wrap">{children}</div>
      </div>
    </>
  );
};

// ── Styles ───────────────────────────────────────────────────────────
// const gameStyles = `
//   :root{
//     --bg0:#05060a;
//     --glass: rgba(255,255,255,.06);
//     --glass2: rgba(255,255,255,.10);
//     --stroke: rgba(255,255,255,.14);
//     --text: rgba(255,255,255,.92);
//     --muted: rgba(255,255,255,.70);
//     --good: #4CFFB0;
//     --bad:  #FF4C7B;
//     --cyan: #36E7FF;
//     --violet:#B46BFF;
//     --gold: #FFD36B;
//     --shadow: 0 20px 60px rgba(0,0,0,.55);
//     --radius: 18px;
//   }

//   .game-root {
  
//     color: var(--text);
//     background:
//       radial-gradient(1200px 800px at 20% 10%, rgba(180,107,255,.15), transparent 55%),
//       radial-gradient(900px 700px at 80% 30%, rgba(54,231,255,.14), transparent 55%),
//       radial-gradient(900px 700px at 50% 90%, rgba(255,211,107,.10), transparent 55%),
//       var(--bg0);
//     font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji","Segoe UI Emoji";
//     overflow: hidden;
//   }

//   .scanlines{
//     pointer-events:none;
//     position:fixed; inset:0;
//     z-index:1;
//     background: repeating-linear-gradient(
//       to bottom,
//       rgba(255,255,255,.03),
//       rgba(255,255,255,.03) 1px,
//       rgba(0,0,0,0) 3px,
//       rgba(0,0,0,0) 6px
//     );
//     mix-blend-mode: overlay;
//     opacity:.32;
//     animation: scan 6s linear infinite;
//   }
//   @keyframes scan{ from{transform:translateY(-10px)} to{transform:translateY(10px)} }

//   .wrap{
//     position:relative;
//     z-index:2;

//     display:grid;
//     place-items:center;
//     padding:18px;
//    width: 100%;
//   max-width: 1400px;
//     margin:0 auto;
//     font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji","Segoe UI Emoji";
//   }

//   .card{
//     width: min(920px, 100%);
//     border-radius: var(--radius);
//     background: linear-gradient(180deg, var(--glass), rgba(255,255,255,.03));
//     border:1px solid var(--stroke);
//     box-shadow: var(--shadow);
//     backdrop-filter: blur(14px);
//     -webkit-backdrop-filter: blur(14px);
//     overflow:hidden;
//     position:relative;
//     display:flex;
//     flex-direction:column;
//     max-height: 420px;
//   }

//   .card::before{
//     content:"";
//     position:absolute; inset:0;
//     background:
//       radial-gradient(600px 220px at 20% 0%, rgba(54,231,255,.18), transparent 60%),
//       radial-gradient(420px 200px at 80% 10%, rgba(180,107,255,.16), transparent 60%);
//     opacity:.9;
//     pointer-events:none;
//   }
//   .card::after{
//     content:"";
//     position:absolute;
//     inset:-2px;
//     border-radius: calc(var(--radius) + 2px);
//     background: conic-gradient(from 180deg,
//       rgba(54,231,255,.20),
//       rgba(180,107,255,.18),
//       rgba(255,211,107,.10),
//       rgba(54,231,255,.20)
//     );
//     filter: blur(14px);
//     opacity:.12;
//     animation: aura 14s linear infinite;
//     pointer-events:none;
//     z-index:0;
//   }
//   @keyframes aura{ from{transform: rotate(0deg)} to{transform: rotate(360deg)} }
//   .card > *{ position:relative; z-index:1; }

//   .card.complete-glow {
//     box-shadow:
//       0 0 60px rgba(54, 231, 255, 0.3),
//       0 0 100px rgba(54, 231, 255, 0.15),
//       0 30px 100px rgba(0,0,0,0.4);
//     border-color: rgba(54, 231, 255, 0.3);
//   }

  // .replay-btn{
  //   margin-top:12px; padding:14px 28px; font-size:15px; font-weight:600;
  //   background: linear-gradient(135deg, rgba(54,231,255,.15), rgba(180,107,255,.15));
  //   border:1px solid rgba(54,231,255,.5); border-radius:12px;
  //   color:var(--text); cursor:pointer; transition: all .2s ease;
  //   position: relative;
  // z-index: 50;
  //  opacity: 1 !important;
  // transform: none !important;
  // }


//   .topbar{
//     display:flex;
//     align-items:flex-start;
//     justify-content:space-between;
//     padding:10px 14px 8px;
//     border-bottom:1px solid rgba(255,255,255,.10);
//     gap:14px;
//   }
//   .title{display:flex; flex-direction:column; gap:4px; min-width:0;}
//   .title h1{margin:0; font-size:16px; letter-spacing:.2px; display:flex; align-items:center; gap:8px;}
//   .title p{margin:0; font-size:12px; color:var(--muted); max-width:70ch;}

//   .badge{
//     display:inline-flex;
//     align-items:center;
//     gap:10px;
//     padding:8px 10px;
//     border-radius:12px;
//     border:1px solid rgba(255,255,255,.12);
//     background: rgba(0,0,0,.18);
//     color:rgba(255,255,255,.86);
//     font-size:12px;
//     box-shadow: 0 10px 24px rgba(0,0,0,.22);
//     white-space:nowrap;
//     flex:0 0 auto;
//   }
//   .dot{
//     width:8px; height:8px; border-radius:50%;
//     background: radial-gradient(circle at 30% 30%, #fff, rgba(255,255,255,.2));
//     box-shadow: 0 0 14px rgba(54,231,255,.55);
//   }
//   .pts{display:inline-flex; align-items:baseline; gap:6px;}
//   .pts b{font-weight:800; color:rgba(255,255,255,.92)}

//   .content{
//     height:100vh;
//     display:flex;
//     flex-direction:column;
//     gap:10px;
//     flex:1;
//     min-height:0;
//   }

//   .instruction{
//     display:flex;
//     align-items:center;
//     justify-content:space-between;
//     gap:12px;
//     padding:20px 18px;
//     border-radius:14px;
//     border:1px solid rgba(255,255,255,.12);
//     background: rgba(0,0,0,.12);
//     min-height:44px;
//   }
//   .instruction .q{
//     font-size:13px;
//     color: rgba(255,255,255,.86);
//     line-height:1.35;
//     display:flex;
//     align-items:center;
//     gap:10px;
//     min-width:0;
//     flex:1;
//   }

//   .arrowKey{
//     display:inline-flex;
//     align-items:center;
//     justify-content:center;
//     width:22px;
//     height:20px;
//     border-radius:6px;
//     border:1px solid rgba(255,255,255,.18);
//     background: rgba(255,255,255,.08);
//     font-weight:700;
//     font-size:11px;
//     color: rgba(255,255,255,.82);
//   }

//   .timer-ring{
//     width:44px;
//     height:44px;
//     flex:0 0 auto;
//     position:relative;
//     margin-left:8px;
//   }
//   .timer-ring svg{ transform: rotate(-90deg); width:100%; height:100%; }
//   .timer-ring.warning .timer-progress{ stroke: var(--gold); }
//   .timer-ring.danger .timer-progress{ stroke: var(--bad); }
//   .timer-ring.danger{ animation: timerPulse .5s ease-in-out infinite; }
//   @keyframes timerPulse{ 0%,100%{ transform: scale(1); } 50%{ transform: scale(1.08); } }
//   .timer-ring .timer-text{
//     position:absolute;
//     inset:0;
//     display:flex;
//     align-items:center;
//     justify-content:center;
//     font-size:13px;
//     font-weight:800;
//     color: rgba(255,255,255,.92);
//   }

//   .board{
//     height:100%;
//     flex:1;
//     min-height:0;
//     border-radius:16px;
//     border:1px solid rgba(255,255,255,.12);
//     background: rgba(0,0,0,.12);
//     padding:10px;
//     display:grid;
//     grid-template-columns: 0.72fr 1.56fr 0.72fr;
//     gap:12px;
//     align-items:stretch;
//   }

//   .side{
//     border-radius:16px;
//     border:1px solid rgba(255,255,255,.12);
//     background: linear-gradient(180deg, rgba(255,255,255,.07), rgba(255,255,255,.02));
//     box-shadow: 0 12px 30px rgba(0,0,0,.18);
//     display:grid;
//     place-items:center;
//     cursor:pointer;
//     user-select:none;
//     transition: transform .15s ease, border-color .15s ease, box-shadow .15s ease, background .15s ease, filter .15s ease;
//     position:relative;
//     overflow:hidden;
//   }
//   .side::before{
//     content:'';
//     position:absolute;
//     inset:-2px;
//     border-radius:16px;
//     background: linear-gradient(90deg, transparent, rgba(54,231,255,.4), transparent);
//     pointer-events:none;
//     opacity:0;
//     transition: opacity 10s ease;
//   }
//   .side:hover::before{
//     opacity:1;
//     animation: btnGlow 4s ease-in-out infinite;
//   }
//   @keyframes btnGlow {
//     0%, 100% { transform: translateX(-100%); }
//     50% { transform: translateX(100%); }
//   }
//   .side:hover{
//     transform: translateY(-1px);
//     border-color: rgba(54,231,255,.35);
//     animation: sideGlow 1.5s ease-in-out infinite;
//   }
//   @keyframes sideGlow {
//     0%, 100% {
//       filter: drop-shadow(0 0 12px rgba(54,231,255,.15));
//       box-shadow: 0 12px 30px rgba(0,0,0,.18), 0 0 15px rgba(54,231,255,.1);
//     }
//     50% {
//       filter: drop-shadow(0 0 25px rgba(54,231,255,.35));
//       box-shadow: 0 12px 30px rgba(0,0,0,.18), 0 0 30px rgba(54,231,255,.25);
//     }
//   }
//   .side:active{ transform: translateY(0) scale(.98); animation: none; }
//   .side:active::before{ animation: none; opacity:0; }
//   .side[disabled]{ opacity:.55; cursor:not-allowed; transform:none; filter:none; animation:none; }
//   .side[disabled]::before{ display:none; }

//   .side .label{
//     display:flex;
//     align-items:center;
//     gap:10px;
//     letter-spacing:.18em;
//     font-size:15px;
//     font-weight:800;
//     color: rgba(255,255,255,.82);
//     justify-content:center;
//   }
//   .pillIcon{
//     width:34px; height:28px;
//     border-radius:12px;
//     border:1px solid rgba(255,255,255,.14);
//     background: rgba(0,0,0,.18);
//     display:grid;
//     place-items:center;
//     box-shadow: 0 10px 18px rgba(0,0,0,.18);
//     color: rgba(255,255,255,.85);
//   }

//   .centre{
//     height:100%;
//     border-radius:16px;
//     border:1px solid rgba(255,255,255,.12);
//     background: rgba(0,0,0,.10);
//     box-shadow: 0 12px 30px rgba(0,0,0,.18);
//     display:flex;
//     flex-direction:column;
//     justify-content:start;
//     position:relative;
//     overflow-x:hidden;
//     overflow-y:auto;
//     padding:10px;
//   }

//   .statementCard{
//     width:100%;
//     flex:1;
//     border-radius:16px;
//     border:1px solid rgba(255,255,255,.14);
//     background: linear-gradient(180deg, rgba(255,255,255,.09), rgba(255,255,255,.03));
//     box-shadow: 0 18px 50px rgba(0,0,0,.22);
//     position:relative;
//     padding:14px 14px 12px;
//     touch-action: pan-y;
//     user-select:none;
//     transform: translateX(0) rotate(0);
//     opacity:1;
//     display:flex;
//     flex-direction:column;
//   }
//   .statementCard::before{
//     content:"";
//     position:absolute; inset:0;
//     background:
//       radial-gradient(520px 220px at 15% 0%, rgba(54,231,255,.10), transparent 60%),
//       radial-gradient(420px 200px at 85% 10%, rgba(180,107,255,.10), transparent 60%);
//     opacity:.9;
//     pointer-events:none;
//   }
//   .statementCard::after{
//     content:"";
//     position:absolute;
//     inset:-2px;
//     background: linear-gradient(90deg, transparent, rgba(54,231,255,.10), transparent);
//     transform: translateX(-70%);
//     animation: shimmer 3.8s ease-in-out infinite;
//     pointer-events:none;
//     opacity:.55;
//   }
//   @keyframes shimmer{ 0%{transform: translateX(-70%)} 55%{transform: translateX(70%)} 100%{transform: translateX(70%)} }

//   .statementCard > *{ position:relative; z-index:1; }
//   .chip{
//     display:inline-flex;
//     align-items:center;
//     justify-content:center;
//     width:2rem; 
//     height:2rem; 
//     border-radius:10px;
//     border:1px solid rgba(255,255,255,.16);
//     background: rgba(0,0,0,.18);
//     color:rgba(255,255,255,.85);
//     font-size:12px;
//     font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial;
//   } 
    
//   .chipTop{
//     display:inline-flex;
//     align-items:center;
//     gap:8px;
//     padding:8px 16px;
//     border-radius:999px;
//     border:1px solid rgba(255,255,255,.10);
//     background: rgba(30,35,45,.85);
//     font-size:13px;
//     font-weight:500;
//     color: rgba(255,255,255,.75);
//     width:fit-content;
//   }

//   .statementText{
//     margin:10px 0 0;
//     font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial;
//     font-size:20px;
//     font-weight:400;
//     line-height:1.35;
//     // letter-spacing:-0.01em;
//     color: rgba(255,255,255,.94);
//   }

//   .swipe-left{ animation: swipeLeft .26s ease-in forwards; }
//   .swipe-right{ animation: swipeRight .26s ease-in forwards; }
//   @keyframes swipeLeft{
//     to{ transform: translateX(-240px) rotate(-6deg); opacity:0; }
//   }
//   @keyframes swipeRight{
//     to{ transform: translateX(240px) rotate(6deg); opacity:0; }
//   }
//   .enter-from-left{ animation: enterLeft .22s ease-out both; }
//   .enter-from-right{ animation: enterRight .22s ease-out both; }
//   @keyframes enterLeft{
//     from{ transform: translateX(-220px) rotate(-4deg); opacity:0; }
//     to{ transform: translateX(0) rotate(0); opacity:1; }
//   }
//   @keyframes enterRight{
//     from{ transform: translateX(220px) rotate(4deg); opacity:0; }
//     to{ transform: translateX(0) rotate(0); opacity:1; }
//   }

//   .overlay{
//     position:absolute;
//     inset:0;
//     display:none;
//     place-items:center;
//     z-index:10;
//     background: rgba(0,0,0,.56);
//     backdrop-filter: blur(10px);
//     -webkit-backdrop-filter: blur(10px);
//     padding:16px;
//   }
//   .overlay.show{ display:grid; }

//   .feedback{
//     width:min(560px, 100%);
//     border-radius:16px;
//     border:1px solid rgba(255,255,255,.14);
//     background: rgba(20,22,35,.92);
//     box-shadow: 0 18px 60px rgba(0,0,0,.60);
//     padding:12px;
//     position:relative;
//     overflow:hidden;
//     animation: pop .18s ease-out;
//     max-height: min(50vh, 380px);
//     overflow:auto;
//   }
//   .feedback::before{
//     content:"";
//     position:absolute; inset:0;
//     background:
//       radial-gradient(520px 220px at 15% 0%, rgba(54,231,255,.12), transparent 60%),
//       radial-gradient(420px 200px at 85% 10%, rgba(180,107,255,.10), transparent 60%);
//     opacity:.9;
//     pointer-events:none;
//   }
//   .feedback > *{ position:relative; z-index:1; }
//   .feedback.good{ border-color: rgba(76,255,176,.25); box-shadow: 0 0 0 1px rgba(76,255,176,.10) inset; }
//   .feedback.bad{ border-color: rgba(255,76,123,.22); box-shadow: 0 0 0 1px rgba(255,76,123,.08) inset; }

//   .fbHead{
//     display:flex;
//     align-items:flex-start;
//     justify-content:space-between;
//     gap:12px;
//     margin-bottom:8px;
//   }
//   .fbHead strong{
//     font-size:13px;
//     letter-spacing:.2px;
//   }
//   .fbBody{
//     margin:10px 0 10px;
//     font-size:13px;
//     color: rgba(255,255,255,.86);
//     line-height:1.5;
//   }

//   .streak-badge {
//     display: inline-flex;
//     align-items: center;
//     gap: 4px;
//     padding: 4px 10px;
//     border-radius: 999px;
//     background: linear-gradient(135deg, #ff6b35, #f7c12f);
//     font-weight: 800;
//     font-size: 13px;
//     color: #000;
//     animation: streakPulse 0.5s ease-in-out;
//   }
//   @keyframes streakPulse {
//     0%, 100% { transform: scale(1); }
//     50% { transform: scale(1.15); }
//   }

//   .streak-popup{
//     position:absolute;
//     top:50%;
//     right:20px;
//     transform: translateY(-50%) scale(0);
//     padding:8px 16px;
//     border-radius:20px;
//     font-size:14px;
//     font-weight:700;
//     color:#fff;
//     pointer-events:none;
//     z-index:50;
//     white-space:nowrap;
//     animation: streakPop 1s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
//   }
//   .streak-popup.nice{
//     background: linear-gradient(135deg, var(--cyan), var(--violet));
//     box-shadow: 0 4px 20px rgba(54,231,255,.4);
//   }
//   .streak-popup.wow{
//     background: linear-gradient(135deg, var(--violet), #FF6BCD);
//     box-shadow: 0 4px 20px rgba(180,107,255,.5);
//   }
//   .streak-popup.unstoppable{
//     background: linear-gradient(135deg, var(--violet), #FF6BCD);
//     box-shadow: 0 4px 20px rgba(180,107,255,.5);
//   }
//   .streak-popup.perfect{
//     background: linear-gradient(135deg, var(--gold), #FF8C00);
//     box-shadow: 0 4px 25px rgba(255,211,107,.6);
//   }
//   @keyframes streakPop{
//     0% { transform: translateY(-50%) scale(0); opacity: 0; }
//     20% { transform: translateY(-50%) scale(1.2); opacity: 1; }
//     40% { transform: translateY(-50%) scale(1); }
//     80% { transform: translateY(-80%) scale(1); opacity: 1; }
//     100% { transform: translateY(-100%) scale(0.8); opacity: 0; }
//   }

//   .fbActions{
//     display:flex;
//     justify-content:flex-end;
//     gap:10px;
//     margin-top:12px;
//   }
//   .ghost{
//     border:1px solid rgba(255,255,255,.16);
//     background: rgba(255,255,255,.06);
//     color: rgba(255,255,255,.86);
//     padding:6px 14px;
//     font-size:13px;
//     border-radius:14px;
//     cursor:pointer;
//     transition: transform .12s ease, filter .12s ease;
//   }
//   .ghost:hover{ transform: translateY(-1px); filter: drop-shadow(0 0 16px rgba(54,231,255,.10)); }
//   .ghost:active{ transform: translateY(0) scale(.99); }

//   @keyframes pop{ from{transform: scale(.985); opacity:0} to{transform: scale(1); opacity:1} }

//   .complete{
//     display:flex;
//     flex-direction:column;
//     align-items:center;
//     justify-content:center;
//     text-align:center;
//     gap:12px;
//     padding:20px 14px;
//     height:100%;
//   }
//   .complete h2{
//     margin:0;
//     font-size:32px;
//     font-weight:800;
//     letter-spacing:.2px;
//     color: #fff;
//   }
//   .complete .subtitle{
//     margin:0;
//     color: rgba(255,255,255,.65);
//     font-size:14px;
//   }
//   .complete .message{
//     margin:0;
//     color: rgba(255,255,255,.72);
//     font-size:14px;
//     max-width: 420px;
//     line-height: 1.5;
//   }
//   .bigScore{
//     margin:12px 0;
//     font-size:36px;
//     font-weight:900;
//     line-height:1.3;
//     letter-spacing:0.5px;
//     text-align: center;
//     background: linear-gradient(180deg, #FFD700 0%, #FFCC00 50%, #FFB800 100%);
//     background-size: 100%;
//     background-repeat: repeat;
//     -webkit-background-clip: text;
//     -webkit-text-fill-color: transparent;
//     background-clip: text;
//     filter:
//       drop-shadow(0 0 25px rgba(255,215,0,.5))
//       drop-shadow(0 0 50px rgba(255,200,0,.3));
//     text-rendering: optimizeLegibility;
//     -webkit-font-smoothing: antialiased;
//   }
//   .replayBtn{
//     margin-top:16px;
//     display:inline-flex;
//     align-items:center;
//     gap:10px;
//     padding:12px 22px;
//     border-radius:12px;
//     border:1px solid rgba(54, 231, 255, 0.3);
//     background: rgba(60, 50, 90, 0.4);
//     color: rgba(255,255,255,.90);
//     cursor:pointer;
//     font-weight:600;
//     font-size:14px;
//     transition: transform .12s ease, border-color .12s ease, box-shadow .12s ease;
//     box-shadow: 0 0 15px rgba(54, 231, 255, 0.1);
//   }
//   .replayBtn:hover{
//     transform: translateY(-2px);
//     border-color: rgba(54, 231, 255, 0.5);
//     box-shadow: 0 0 25px rgba(54, 231, 255, 0.2);
//   }
//   .replayBtn:active{ transform: translateY(0) scale(.98); }

//   /* Wipe transition */
//   .wipe{
//     position:absolute; inset:0;
//     background: radial-gradient(700px 280px at 50% 50%, rgba(54,231,255,.10), rgba(0,0,0,.85));
//     place-items:center;
//     z-index:5;
//     backdrop-filter: blur(10px);
//   }
//   .wipe .msg{
//     text-align:center;
//     padding:18px 18px;
//     border-radius:16px;
//     border:1px solid rgba(255,255,255,.14);
//     background: rgba(0,0,0,.28);
//     box-shadow: 0 20px 60px rgba(0,0,0,.55);
//   }
//   .bar{margin-top:12px; height:10px; border-radius:999px; background: rgba(255,255,255,.08); border:1px solid rgba(255,255,255,.12); overflow:hidden;}
//   .bar > i{
//     display:block;
//     height:100%;
//     width:40%;
//     background: linear-gradient(90deg, rgba(255,255,255,.4), rgba(255,255,255,.6));
//     border-radius:999px;
//     animation: load 900ms ease-in-out infinite alternate;
//   }
//   @keyframes load{from{transform: translateX(-60%)} to{transform: translateX(140%)}}

//   @media (max-width: 760px){
//     .card{ max-height: calc(100vh - 56px); }
//     .board{ grid-template-columns: 1fr; }
//     .side{ min-height: 72px; }
//     .statementText{ font-size:17px; }
//     .instruction{ min-height: 44px; }
//   }

//   @media (prefers-reduced-motion: reduce){
//     .scanlines{animation:none}
//     .card::after{animation:none}
//     .statementCard::after{animation:none}
//     .swipe-left,.swipe-right,.enter-from-left,.enter-from-right{ animation:none !important; }
//   }

//     @media (min-resolution: 1.25dppx) {

//   /* 🔥 CARD SIZE INCREASE */
//   .card{
//     width: 100%;
//     max-width: 1600px;  
//     max-height: none; /* remove height restriction */
//   }

//   /* 🔥 BOARD FULL HEIGHT */
//   .board{
//     height: 70%;
//     min-height: 260px;

//     display: grid;
//     grid-template-columns: 1fr 2fr 1fr; /* LEFT - CENTER - RIGHT */
//     gap: 16px;
//   }

//   /* 🔥 LEFT & RIGHT SIDE BIG */
//   .side{
//     height: 70%;
//     min-height: 260px;

//     display: flex;
//     align-items: center;
//     justify-content: center;

//     font-size: 18px;
//   }

//   /* 🔥 CENTER EXPAND */
//   .centre{
//     height: 100%;
//      width: 100%;
//     display: flex;
//   }

//   .statementCard{
//     height: 100%;
//     width: 100%;
//   }

//   /* 🔥 WRAP LITTLE ZOOM */
//   .wrap{
  
//     width: 90%;
//     max-width: 1600px;   /* increase pannunga */
//     margin: 0 auto;

//     zoom: 0.60; /* adjust pannalam 0.8 - 0.9 */
//   }

// }
// `;



const gameStyles = `
  :root{
    --bg0:#05060a;
    --glass: rgba(255,255,255,.06);
    --glass2: rgba(255,255,255,.10);
    --stroke: rgba(255,255,255,.14);
    --text: rgba(255,255,255,.92);
    --muted: rgba(255,255,255,.70);
    --good: #4CFFB0;
    --bad:  #FF4C7B;
    --cyan: #36E7FF;
    --violet:#B46BFF;
    --gold: #FFD36B;
    --shadow: 0 20px 60px rgba(0,0,0,.55);
    --radius: 18px;
  }

  .game-root {
  
    color: var(--text);
    background:
      radial-gradient(1200px 800px at 20% 10%, rgba(180,107,255,.15), transparent 55%),
      radial-gradient(900px 700px at 80% 30%, rgba(54,231,255,.14), transparent 55%),
      radial-gradient(900px 700px at 50% 90%, rgba(255,211,107,.10), transparent 55%),
      var(--bg0);
    font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji","Segoe UI Emoji";
    overflow: hidden;
  }

  .scanlines{
    pointer-events:none;
    position:fixed; inset:0;
    z-index:1;
    background: repeating-linear-gradient(
      to bottom,
      rgba(255,255,255,.03),
      rgba(255,255,255,.03) 1px,
      rgba(0,0,0,0) 3px,
      rgba(0,0,0,0) 6px
    );
    mix-blend-mode: overlay;
    opacity:.32;
    animation: scan 6s linear infinite;
  }
  @keyframes scan{ from{transform:translateY(-10px)} to{transform:translateY(10px)} }

  .wrap{
      min-height:63vh;
      height:120px;
    position:relative;
    z-index:2;

    display:grid;
    place-items:center;
    padding:18px;
    width:min(94vw, 70rem);
      max-height:85vh;
      overflow-y:auto;
      overflow-x:hidden;
    margin:0 auto;
    font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji","Segoe UI Emoji";
 }
 @media (min-resolution: 1.25dppx) {
  .card {
    zoom: 0.92;
  }
}
 

  // .card{
  //   width: min(920px, 100%);
  //   border-radius: var(--radius);
  //   background: linear-gradient(180deg, var(--glass), rgba(255,255,255,.03));
  //   border:1px solid var(--stroke);
  //   box-shadow: var(--shadow);
  //   backdrop-filter: blur(14px);
  //   -webkit-backdrop-filter: blur(14px);
  //   overflow:hidden;
  //   position:relative;
  //   display:flex;
  //   flex-direction:column;
  //   height: 420px;
  // }

    .card{
    // width: min(920px, 100%);
    width:100%;
    border-radius: var(--radius);
    background: linear-gradient(180deg, var(--glass), rgba(255,255,255,.03));
    border:1px solid var(--stroke);
    box-shadow: var(--shadow);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
    overflow:hidden;
    position:relative;
    display:flex;
    flex-direction:column;
    height: 100%;
  }

//   /* Scrollbar */
  .chat::-webkit-scrollbar { width: 10px; }
  .chat::-webkit-scrollbar-track { background: rgba(255,255,255,.05); border-radius: 4px; }
  .chat::-webkit-scrollbar-thumb { background: rgba(54,231,255,.35); border: 2px solid transparent; background-clip: padding-box; border-radius: 4px; }
  .chat::-webkit-scrollbar-thumb:hover { background: rgba(54,231,255,.5); }
  .chat { scrollbar-width: auto; scrollbar-color: rgba(54,231,255,.35) rgba(255,255,255,.05); }
  
.wrap::-webkit-scrollbar { width: 10px; }
  .wrap::-webkit-scrollbar-track { background: rgba(255,255,255,.05); border-radius: 4px; }
  .wrap::-webkit-scrollbar-thumb { background: rgba(54,231,255,.35); border: 2px solid transparent; background-clip: padding-box; border-radius: 4px; }
  .wrap::-webkit-scrollbar-thumb:hover { background: rgba(54,231,255,.5); }
  .wrap { scrollbar-width: auto; scrollbar-color: rgba(54,231,255,.35) rgba(255,255,255,.05); }


  .card::before{
    content:"";
    position:absolute; inset:0;
    background:
      radial-gradient(600px 220px at 20% 0%, rgba(54,231,255,.18), transparent 60%),
      radial-gradient(420px 200px at 80% 10%, rgba(180,107,255,.16), transparent 60%);
    opacity:.9;
    pointer-events:none;
  }
  .card::after{
    content:"";
    position:absolute;
    inset:-2px;
    border-radius: calc(var(--radius) + 2px);
    background: conic-gradient(from 180deg,
      rgba(54,231,255,.20),
      rgba(180,107,255,.18),
      rgba(255,211,107,.10),
      rgba(54,231,255,.20)
    );
    filter: blur(14px);
    opacity:.12;
    animation: aura 14s linear infinite;
    pointer-events:none;
    z-index:0;
  }
  @keyframes aura{ from{transform: rotate(0deg)} to{transform: rotate(360deg)} }
  .card > *{ position:relative; z-index:1; }

  .card.complete-glow {
    box-shadow:
      0 0 60px rgba(54, 231, 255, 0.3),
      0 0 100px rgba(54, 231, 255, 0.15),
      0 30px 100px rgba(0,0,0,0.4);
    border-color: rgba(54, 231, 255, 0.3);
  }

    .replay-btn{
    margin-top:12px; padding:14px 28px; font-size:15px; font-weight:600;
    background: linear-gradient(135deg, rgba(54,231,255,.15), rgba(180,107,255,.15));
    border:1px solid rgba(54,231,255,.5); border-radius:12px;
    color:var(--text); cursor:pointer; transition: all .2s ease;
    position: relative;
  z-index: 50;
   opacity: 1 !important;
  transform: none !important;
  }

  .topbar{
    display:flex;
    align-items:flex-start;
    justify-content:space-between;
    padding:10px 14px 8px;
    border-bottom:1px solid rgba(255,255,255,.10);
    gap:14px;
  }
  .title{display:flex; flex-direction:column; gap:4px; min-width:0;}
  .title h1{margin:0; font-size:16px; letter-spacing:.2px; display:flex; align-items:center; gap:8px;}
  .title p{margin:0; font-size:12px; color:var(--muted); max-width:70ch;}




  .badge{
    display:inline-flex;
    align-items:center;
    gap:10px;
    padding:8px 10px;
    border-radius:12px;
    border:1px solid rgba(255,255,255,.12);
    background: rgba(0,0,0,.18);
    color:rgba(255,255,255,.86);
    font-size:12px;
    box-shadow: 0 10px 24px rgba(0,0,0,.22);
    white-space:nowrap;
    flex:0 0 auto;
  }
  .dot{
    width:8px; height:8px; border-radius:50%;
    background: radial-gradient(circle at 30% 30%, #fff, rgba(255,255,255,.2));
    box-shadow: 0 0 14px rgba(54,231,255,.55);
  }
  .pts{display:inline-flex; align-items:baseline; gap:6px;}
  .pts b{font-weight:800; color:rgba(255,255,255,.92)}

  .content{
    height:100vh;
    display:flex;
    flex-direction:column;
    gap:10px;
    flex:1;
    min-height:0;
  }

  .instruction{
    display:flex;
    align-items:center;
    justify-content:space-between;
    gap:12px;
    padding:20px 18px;
    border-radius:14px;
    border:1px solid rgba(255,255,255,.12);
    background: rgba(0,0,0,.12);
    min-height:44px;
  }
  .instruction .q{
    font-size:13px;
    color: rgba(255,255,255,.86);
    line-height:1.35;
    display:flex;
    align-items:center;
    gap:10px;
    min-width:0;
    flex:1;
  }

  .arrowKey{
    display:inline-flex;
    align-items:center;
    justify-content:center;
    width:22px;
    height:20px;
    border-radius:6px;
    border:1px solid rgba(255,255,255,.18);
    background: rgba(255,255,255,.08);
    font-weight:700;
    font-size:11px;
    color: rgba(255,255,255,.82);
  }

  .timer-ring{
    width:44px;
    height:44px;
    flex:0 0 auto;
    position:relative;
    margin-left:8px;
  }
  .timer-ring svg{ transform: rotate(-90deg); width:100%; height:100%; }
  .timer-ring.warning .timer-progress{ stroke: var(--gold); }
  .timer-ring.danger .timer-progress{ stroke: var(--bad); }
  .timer-ring.danger{ animation: timerPulse .5s ease-in-out infinite; }
  @keyframes timerPulse{ 0%,100%{ transform: scale(1); } 50%{ transform: scale(1.08); } }
  .timer-ring .timer-text{
    position:absolute;
    inset:0;
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:13px;
    font-weight:800;
    color: rgba(255,255,255,.92);
  }

  .board{
    height:100%;
    flex:1;
    min-height:0;
    border-radius:16px;
    border:1px solid rgba(255,255,255,.12);
    background: rgba(0,0,0,.12);
    padding:10px;
    display:grid;
    grid-template-columns: 0.72fr 1.56fr 0.72fr;
    gap:12px;
    align-items:stretch;
  }

  .side{
    border-radius:16px;
    border:1px solid rgba(255,255,255,.12);
    background: linear-gradient(180deg, rgba(255,255,255,.07), rgba(255,255,255,.02));
    box-shadow: 0 12px 30px rgba(0,0,0,.18);
    display:grid;
    place-items:center;
    cursor:pointer;
    user-select:none;
    transition: transform .15s ease, border-color .15s ease, box-shadow .15s ease, background .15s ease, filter .15s ease;
    position:relative;
    overflow:hidden;
  }
  .side::before{
    content:'';
    position:absolute;
    inset:-2px;
    border-radius:16px;
    background: linear-gradient(90deg, transparent, rgba(54,231,255,.4), transparent);
    pointer-events:none;
    opacity:0;
    transition: opacity 10s ease;
  }
  .side:hover::before{
    opacity:1;
    animation: btnGlow 4s ease-in-out infinite;
  }
  @keyframes btnGlow {
    0%, 100% { transform: translateX(-100%); }
    50% { transform: translateX(100%); }
  }
  .side:hover{
    transform: translateY(-1px);
    border-color: rgba(54,231,255,.35);
    animation: sideGlow 1.5s ease-in-out infinite;
  }
  @keyframes sideGlow {
    0%, 100% {
      filter: drop-shadow(0 0 12px rgba(54,231,255,.15));
      box-shadow: 0 12px 30px rgba(0,0,0,.18), 0 0 15px rgba(54,231,255,.1);
    }
    50% {
      filter: drop-shadow(0 0 25px rgba(54,231,255,.35));
      box-shadow: 0 12px 30px rgba(0,0,0,.18), 0 0 30px rgba(54,231,255,.25);
    }
  }
  .side:active{ transform: translateY(0) scale(.98); animation: none; }
  .side:active::before{ animation: none; opacity:0; }
  .side[disabled]{ opacity:.55; cursor:not-allowed; transform:none; filter:none; animation:none; }
  .side[disabled]::before{ display:none; }

  .side .label{
    display:flex;
    align-items:center;
    gap:10px;
    letter-spacing:.18em;
    font-size:15px;
    font-weight:800;
    color: rgba(255,255,255,.82);
    justify-content:center;
  }
  .pillIcon{
    width:34px; height:28px;
    border-radius:12px;
    border:1px solid rgba(255,255,255,.14);
    background: rgba(0,0,0,.18);
    display:grid;
    place-items:center;
    box-shadow: 0 10px 18px rgba(0,0,0,.18);
    color: rgba(255,255,255,.85);
  }

  .centre{
    height:100%;
    border-radius:16px;
    border:1px solid rgba(255,255,255,.12);
    background: rgba(0,0,0,.10);
    box-shadow: 0 12px 30px rgba(0,0,0,.18);
    display:flex;
    flex-direction:column;
    justify-content:start;
    position:relative;
    overflow-x:hidden;
    overflow-y:auto;
    padding:10px;
  }

  .statementCard{
    width:100%;
    flex:1;
    border-radius:16px;
    border:1px solid rgba(255,255,255,.14);
    background: linear-gradient(180deg, rgba(255,255,255,.09), rgba(255,255,255,.03));
    box-shadow: 0 18px 50px rgba(0,0,0,.22);
    position:relative;
    padding:14px 14px 12px;
    touch-action: pan-y;
    user-select:none;
    transform: translateX(0) rotate(0);
    opacity:1;
    display:flex;
    flex-direction:column;
  }
  .statementCard::before{
    content:"";
    position:absolute; inset:0;
    background:
      radial-gradient(520px 220px at 15% 0%, rgba(54,231,255,.10), transparent 60%),
      radial-gradient(420px 200px at 85% 10%, rgba(180,107,255,.10), transparent 60%);
    opacity:.9;
    pointer-events:none;
  }
  .statementCard::after{
    content:"";
    position:absolute;
    inset:-2px;
    background: linear-gradient(90deg, transparent, rgba(54,231,255,.10), transparent);
    transform: translateX(-70%);
    animation: shimmer 3.8s ease-in-out infinite;
    pointer-events:none;
    opacity:.55;
  }
  @keyframes shimmer{ 0%{transform: translateX(-70%)} 55%{transform: translateX(70%)} 100%{transform: translateX(70%)} }

  .statementCard > *{ position:relative; z-index:1; }
  .chip{
    display:inline-flex;
    align-items:center;
    justify-content:center;
    width:2rem; 
    height:2rem; 
    border-radius:10px;
    border:1px solid rgba(255,255,255,.16);
    background: rgba(0,0,0,.18);
    color:rgba(255,255,255,.85);
    font-size:12px;
    font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial;
  } 
    
  .chipTop{
    display:inline-flex;
    align-items:center;
    gap:8px;
    padding:8px 16px;
    border-radius:999px;
    border:1px solid rgba(255,255,255,.10);
    background: rgba(30,35,45,.85);
    font-size:13px;
    font-weight:500;
    color: rgba(255,255,255,.75);
    width:fit-content;
  }

  .statementText{
    margin:10px 0 0;
    font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial;
    font-size:20px;
    font-weight:400;
    line-height:1.35;
    // letter-spacing:-0.01em;
    color: rgba(255,255,255,.94);
  }

  .swipe-left{ animation: swipeLeft .26s ease-in forwards; }
  .swipe-right{ animation: swipeRight .26s ease-in forwards; }
  @keyframes swipeLeft{
    to{ transform: translateX(-240px) rotate(-6deg); opacity:0; }
  }
  @keyframes swipeRight{
    to{ transform: translateX(240px) rotate(6deg); opacity:0; }
  }
  .enter-from-left{ animation: enterLeft .22s ease-out both; }
  .enter-from-right{ animation: enterRight .22s ease-out both; }
  @keyframes enterLeft{
    from{ transform: translateX(-220px) rotate(-4deg); opacity:0; }
    to{ transform: translateX(0) rotate(0); opacity:1; }
  }
  @keyframes enterRight{
    from{ transform: translateX(220px) rotate(4deg); opacity:0; }
    to{ transform: translateX(0) rotate(0); opacity:1; }
  }

  .overlay{
    position:absolute;
    inset:0;
    display:none;
    place-items:center;
    z-index:10;
    background: rgba(0,0,0,.56);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    padding:16px;
  }
  .overlay.show{ display:grid; }

  .feedback{
    width:min(560px, 100%);
    border-radius:16px;
    border:1px solid rgba(255,255,255,.14);
    background: rgba(20,22,35,.92);
    box-shadow: 0 18px 60px rgba(0,0,0,.60);
    padding:12px;
    position:relative;
    overflow:hidden;
    animation: pop .18s ease-out;
    max-height: min(50vh, 380px);
    overflow:auto;
  }
  .feedback::before{
    content:"";
    position:absolute; inset:0;
    background:
      radial-gradient(520px 220px at 15% 0%, rgba(54,231,255,.12), transparent 60%),
      radial-gradient(420px 200px at 85% 10%, rgba(180,107,255,.10), transparent 60%);
    opacity:.9;
    pointer-events:none;
  }
  .feedback > *{ position:relative; z-index:1; }
  .feedback.good{ border-color: rgba(76,255,176,.25); box-shadow: 0 0 0 1px rgba(76,255,176,.10) inset; }
  .feedback.bad{ border-color: rgba(255,76,123,.22); box-shadow: 0 0 0 1px rgba(255,76,123,.08) inset; }

  .fbHead{
    display:flex;
    align-items:flex-start;
    justify-content:space-between;
    gap:12px;
    margin-bottom:8px;
  }
  .fbHead strong{
    font-size:13px;
    letter-spacing:.2px;
  }
  .fbBody{
    margin:10px 0 10px;
    font-size:13px;
    color: rgba(255,255,255,.86);
    line-height:1.5;
  }

  .streak-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 10px;
    border-radius: 999px;
    background: linear-gradient(135deg, #ff6b35, #f7c12f);
    font-weight: 800;
    font-size: 13px;
    color: #000;
    animation: streakPulse 0.5s ease-in-out;
  }
  @keyframes streakPulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.15); }
  }

  .streak-popup{
    position:absolute;
    top:50%;
    right:20px;
    transform: translateY(-50%) scale(0);
    padding:8px 16px;
    border-radius:20px;
    font-size:14px;
    font-weight:700;
    color:#fff;
    pointer-events:none;
    z-index:50;
    white-space:nowrap;
    animation: streakPop 1s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
  }
  .streak-popup.nice{
    background: linear-gradient(135deg, var(--cyan), var(--violet));
    box-shadow: 0 4px 20px rgba(54,231,255,.4);
  }
  .streak-popup.wow{
    background: linear-gradient(135deg, var(--violet), #FF6BCD);
    box-shadow: 0 4px 20px rgba(180,107,255,.5);
  }
  .streak-popup.unstoppable{
    background: linear-gradient(135deg, var(--violet), #FF6BCD);
    box-shadow: 0 4px 20px rgba(180,107,255,.5);
  }
  .streak-popup.perfect{
    background: linear-gradient(135deg, var(--gold), #FF8C00);
    box-shadow: 0 4px 25px rgba(255,211,107,.6);
  }
  @keyframes streakPop{
    0% { transform: translateY(-50%) scale(0); opacity: 0; }
    20% { transform: translateY(-50%) scale(1.2); opacity: 1; }
    40% { transform: translateY(-50%) scale(1); }
    80% { transform: translateY(-80%) scale(1); opacity: 1; }
    100% { transform: translateY(-100%) scale(0.8); opacity: 0; }
  }

  .fbActions{
    display:flex;
    justify-content:flex-end;
    gap:10px;
    margin-top:12px;
  }
  .ghost{
    border:1px solid rgba(255,255,255,.16);
    background: rgba(255,255,255,.06);
    color: rgba(255,255,255,.86);
    padding:6px 14px;
    font-size:13px;
    border-radius:14px;
    cursor:pointer;
    transition: transform .12s ease, filter .12s ease;
  }
  .ghost:hover{ transform: translateY(-1px); filter: drop-shadow(0 0 16px rgba(54,231,255,.10)); }
  .ghost:active{ transform: translateY(0) scale(.99); }

  @keyframes pop{ from{transform: scale(.985); opacity:0} to{transform: scale(1); opacity:1} }

  .complete{
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    text-align:center;
    gap:12px;
    padding:20px 14px;
    height:100%;
  }
  .complete h2{
    margin:0;
    font-size:32px;
    font-weight:800;
    letter-spacing:.2px;
    color: #fff;
  }
  .complete .subtitle{
    margin:0;
    color: rgba(255,255,255,.65);
    font-size:14px;
  }
  .complete .message{
    margin:0;
    color: rgba(255,255,255,.72);
    font-size:14px;
    max-width: 420px;
    line-height: 1.5;
  }
  .bigScore{
    margin:12px 0;
    font-size:36px;
    font-weight:900;
    line-height:1.3;
    letter-spacing:0.5px;
    text-align: center;
    background: linear-gradient(180deg, #FFD700 0%, #FFCC00 50%, #FFB800 100%);
    background-size: 100%;
    background-repeat: repeat;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    filter:
      drop-shadow(0 0 25px rgba(255,215,0,.5))
      drop-shadow(0 0 50px rgba(255,200,0,.3));
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
  }
  .replayBtn{
    margin-top:16px;
    display:inline-flex;
    align-items:center;
    gap:10px;
    padding:12px 22px;
    border-radius:12px;
    border:1px solid rgba(54, 231, 255, 0.3);
    background: rgba(60, 50, 90, 0.4);
    color: rgba(255,255,255,.90);
    cursor:pointer;
    font-weight:600;
    font-size:14px;
    transition: transform .12s ease, border-color .12s ease, box-shadow .12s ease;
    box-shadow: 0 0 15px rgba(54, 231, 255, 0.1);
  }
  .replayBtn:hover{
    transform: translateY(-2px);
    border-color: rgba(54, 231, 255, 0.5);
    box-shadow: 0 0 25px rgba(54, 231, 255, 0.2);
  }
  .replayBtn:active{ transform: translateY(0) scale(.98); }

  /* Wipe transition */
  .wipe{
    position:absolute; inset:0;
    background: radial-gradient(700px 280px at 50% 50%, rgba(54,231,255,.10), rgba(0,0,0,.85));
    place-items:center;
    z-index:5;
    backdrop-filter: blur(10px);
  }
  .wipe .msg{
    text-align:center;
    padding:18px 18px;
    border-radius:16px;
    border:1px solid rgba(255,255,255,.14);
    background: rgba(0,0,0,.28);
    box-shadow: 0 20px 60px rgba(0,0,0,.55);
  }
  .bar{margin-top:12px; height:10px; border-radius:999px; background: rgba(255,255,255,.08); border:1px solid rgba(255,255,255,.12); overflow:hidden;}
  .bar > i{
    display:block;
    height:100%;
    width:40%;
    background: linear-gradient(90deg, rgba(255,255,255,.4), rgba(255,255,255,.6));
    border-radius:999px;
    animation: load 900ms ease-in-out infinite alternate;
  }
  @keyframes load{from{transform: translateX(-60%)} to{transform: translateX(140%)}}

  @media (max-width: 760px){
    .card{ max-height: calc(100vh - 56px); }
    .board{ grid-template-columns: 1fr; }
    .side{ min-height: 72px; }
    .statementText{ font-size:17px; }
    .instruction{ min-height: 44px; }
  }

  @media (prefers-reduced-motion: reduce){
    .scanlines{animation:none}
    .card::after{animation:none}
    .statementCard::after{animation:none}
    .swipe-left,.swipe-right,.enter-from-left,.enter-from-right{ animation:none !important; }
  }
`;
export default SwipeMiniGame;